export enum ApiError {
  OtherError = 1,
  NotFound = 2,
  AlreadyExist = 3,
  AlreadyInUse = 4,
  DatabaseError = 5,
  SendEmailError = 6,
  WrongDate = 7,
  PasswordIsNotGoodEnough = 8,
  UserWrongPassword = 9,
  UserPasswordResetTokenExpired = 10,
  RefreshTokenExpired = 11,
  TypeUserNotChoose = 12,
  AccessDenied = 13,
  DateAvailabilityError = 14,
  AlreadyExistsIncludes = 15,
  GoogleApiError = 16,
  ConfirmingOffersTokenExpired = 17,
  TooManySubcontractors = 18,
  FieldRequired = 19,
  TooManyPositions = 20,
  PasswordReset = 21,
  WrongTypeOfOrder = 22,
  LoginAlreadyExist = 34,
  EmailAlreadyExist = 35,
  AlreadyPlaced = 36,
}
